import FacebookEventManager from "../analytics/FacebookEventManager";
import GoogleEventManager from "../analytics/GoogleEventManager";
import TikTokEventManager from "../analytics/TikTokEventManager";

const subscribers = [GoogleEventManager, TikTokEventManager];
// Only send Facebook Pixel browser events if server events are inactive.
if (!window.Jumpseller.store.fbConversionsApiActive) {
  subscribers.push(FacebookEventManager);
}

export const notifyAnalytics =
  ({ dispatch, getState }) =>
  (next) =>
  (action) => {
    next(action);

    subscribers.forEach((subscriber) => {
      subscriber(action, getState());
    });
  };
